import api from '../../../services/Api';
import { IAuditoriaCreditoEstagnadoResultado } from '../interfaces/IAuditoriaCreditoEstagnado';

interface BuscarParams {
  empresaId: number;
  periodo: string | undefined;
}

export const AuditoriaCreditoEstagnadoService = {
  buscarResultado: async (params: BuscarParams): Promise<IAuditoriaCreditoEstagnadoResultado> => {
    const response = await api.get<IAuditoriaCreditoEstagnadoResultado>(
      'auditoria-credito-estagnado/resultado',
      { params: { empresaIds: params.empresaId, periodo: params.periodo } }
    );
    return response.data;
  },
};
